// Valida data de nascimento. Aceita ISO ("YYYY-MM-DD" — input type="date") ou
// Date. Regras pedidas pelo usuário:
//   - Não pode ter mais de 100 anos
//   - Não pode ser muito recente (5 anos é o mínimo razoável pra carteirinha de estudante)
//   - Não pode ser data futura
//   - Tem que ser uma data real (não "31/02")

const IDADE_MINIMA = 5;
const IDADE_MAXIMA = 100;

function calcularIdade(nascimento, hoje = new Date()) {
    let idade = hoje.getFullYear() - nascimento.getFullYear();
    const mes = hoje.getMonth() - nascimento.getMonth();
    if (mes < 0 || (mes === 0 && hoje.getDate() < nascimento.getDate())) {
        idade--;
    }
    return idade;
}

export function validateDateOfBirth(input) {
    if (!input) return { valid: false, error: 'Informe a data de nascimento.' };

    let nascimento;
    if (input instanceof Date) {
        nascimento = input;
    } else {
        const s = String(input).trim();
        // Aceita "YYYY-MM-DD" (HTML input) ou ISO completo
        if (!/^\d{4}-\d{2}-\d{2}/.test(s)) {
            return { valid: false, error: 'Use o formato AAAA-MM-DD.' };
        }
        // Constrói a Date de forma local (sem UTC drift de "new Date('YYYY-MM-DD')").
        const [ano, mes, dia] = s.slice(0, 10).split('-').map(Number);
        nascimento = new Date(ano, mes - 1, dia);

        // Detecta data irreal (ex: 31/02 vira 3/03 — guard contra isso).
        if (
            nascimento.getFullYear() !== ano ||
            nascimento.getMonth() !== mes - 1 ||
            nascimento.getDate() !== dia
        ) {
            return { valid: false, error: 'Data inválida.' };
        }
    }

    if (Number.isNaN(nascimento.getTime())) {
        return { valid: false, error: 'Data inválida.' };
    }

    const hoje = new Date();
    if (nascimento > hoje) {
        return { valid: false, error: 'A data não pode ser no futuro.' };
    }

    const idade = calcularIdade(nascimento, hoje);
    if (idade < IDADE_MINIMA) {
        return { valid: false, error: `Idade mínima é ${IDADE_MINIMA} anos.` };
    }
    if (idade > IDADE_MAXIMA) {
        return { valid: false, error: `Idade máxima é ${IDADE_MAXIMA} anos.` };
    }

    return { valid: true, idade };
}
